import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import EmojiItem from "@/components/cards/EmojiItem/EmojiItem.vue";
import { ref } from "vue";

interface Props {
  emoji: string;
  size?: number;
}
interface Emits {
  (e: "insert-emoji", emoji: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageEmojiReactionsPanelItem',
  props: {
    emoji: {},
    size: {}
  },
  emits: ["insert-emoji"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;
const isEnlarged = ref(false);

const insertEmoji = (emoji: string) => {
  emit("insert-emoji", emoji);
};

const enlarge = () => {
  isEnlarged.value = true;
};

const shrink = () => {
  isEnlarged.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EmojiItem, {
    emoji: _ctx.emoji,
    size: _ctx.size,
    class: _normalizeClass({ reactionsPanelItem: true, isEnlarged: isEnlarged.value }),
    onInsertEmoji: insertEmoji,
    onMouseenter: enlarge,
    onMouseleave: shrink
  }, null, 8, ["emoji", "size", "class"]))
}
}

})